/**
 * The notification template types supported by the platform.
 *
 * A PostgreSQL check constraint on `notification_email_templates.type` and
 * `notification_sms_templates.type` enforces this exact set, so the UI and the
 * database cannot drift.
 */
export const NOTIFICATION_TEMPLATE_TYPES = [
    'ACCOUNT_VERIFY',
    'PAYMENT_REQUEST',
    'PASSWORD_RESET',
    'FEEDBACK_REQUEST',
    'BOOKING_CONFIRMATION',
    'FEEDBACK_NOTIFICATION',
    'PENDING_BOOKING',
    'PREAUTH_PENDING',
];
/**
 * The same types, in the shape the admin portal's dropdowns expect.
 *
 * Labels are sentence-cased prose; values are the exact database enum values.
 */
export const NOTIFICATION_TEMPLATE_TYPE_OPTIONS = [
    { value: 'ACCOUNT_VERIFY', label: 'Account verify' },
    { value: 'PAYMENT_REQUEST', label: 'Payment request' },
    { value: 'PASSWORD_RESET', label: 'Password reset' },
    { value: 'FEEDBACK_REQUEST', label: 'Feedback request' },
    { value: 'BOOKING_CONFIRMATION', label: 'Booking confirmation' },
    { value: 'FEEDBACK_NOTIFICATION', label: 'Feedback notification' },
    { value: 'PENDING_BOOKING', label: 'Pending booking' },
    { value: 'PREAUTH_PENDING', label: 'Preauth pending' },
];
//# sourceMappingURL=notification-template-types.js.map